import React from "react";
import { statusClass, PRIORITY } from "@/lib/statusColors";

export function StatusBadge({ status, priority }) {
  if (!status && !priority) return null;
  const cls = priority ? PRIORITY[priority] || "bg-slate-500/15 text-slate-300" : statusClass(status);
  return (
    <span data-testid={`badge-${(status || priority).replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}>
      {status || priority}
    </span>
  );
}
